var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableActionBar',{attrs:{"position":"bottom"}},[_c('div',{staticClass:"flex-1"}),_c('Pagination',{attrs:{"itemCount":85}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }